// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.plan-selection-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(195, 191, 191, 0.721);
  backdrop-filter: blur(4px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10000;
  padding: 20px;
}
.plan-selection-modal-overlay .plan-selection-modal {
  background: linear-gradient(135deg, #ffffff 0%, #f8fafc 100%);
  border-radius: 16px;
  box-shadow: 0 25px 50px rgba(0, 0, 0, 0.3);
  max-width: 900px;
  width: 100%;
  max-height: 90vh;
  overflow-y: auto;
  animation: modalSlideIn 0.3s ease-out;
  border: 1px solid #e2e8f0;
}
@keyframes modalSlideIn {
  from {
    opacity: 0;
    transform: translateY(-20px) scale(0.95);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}
.plan-selection-modal-overlay .plan-selection-modal .modal-header {
  padding: 16px 24px;
  display: flex;
  justify-content: flex-end;
  border-bottom: 1px solid #e2e8f0;
}
.plan-selection-modal-overlay .plan-selection-modal .modal-header .close-button {
  background: transparent;
  border: none;
  font-size: 24px;
  color: #4a5568;
  cursor: pointer;
  transition: color 0.3s ease;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}
.plan-selection-modal-overlay .plan-selection-modal .modal-header .close-button:hover:not(:disabled) {
  color: #2d3748;
}
.plan-selection-modal-overlay .plan-selection-modal .modal-header .close-button:disabled {
  color: #cbd5e0;
  cursor: not-allowed;
  opacity: 0.5;
}
.plan-selection-modal-overlay .plan-selection-modal .loading-container {
  padding: 60px 32px;
  text-align: center;
  color: #4a5568;
  font-size: 16px;
}
.plan-selection-modal-overlay .plan-selection-modal .company-info {
  padding: 24px 32px;
  text-align: center;
  border-bottom: 1px solid #e2e8f0;
  background: #f8fafc;
}
.plan-selection-modal-overlay .plan-selection-modal .company-info h2 {
  margin: 0 0 12px;
  font-size: 26px;
  font-weight: 700;
  color: #1a202c;
}
.plan-selection-modal-overlay .plan-selection-modal .company-info .contact-info {
  margin-bottom: 8px;
  font-size: 14px;
  color: #4a5568;
}
.plan-selection-modal-overlay .plan-selection-modal .company-info .contact-info span {
  margin: 0 4px;
}
.plan-selection-modal-overlay .plan-selection-modal .company-info .current-plan {
  font-size: 14px;
  color: #4a5568;
}
.plan-selection-modal-overlay .plan-selection-modal .company-info .current-plan strong {
  color: var(--primary-color);
  font-weight: 600;
}
.plan-selection-modal-overlay .plan-selection-modal .plan-content {
  padding: 32px;
}
.plan-selection-modal-overlay .plan-selection-modal .plan-content .section-title {
  margin: 0 0 20px;
  font-size: 18px;
  font-weight: 600;
  color: #2d3748;
}
.plan-selection-modal-overlay .plan-selection-modal .plan-content .plans-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 20px;
  margin-bottom: 32px;
}
.plan-selection-modal-overlay .plan-selection-modal .plan-content .plans-grid .plan-card {
  position: relative;
  background: white;
  border: 2px solid #e2e8f0;
  border-radius: 12px;
  padding: 24px 20px;
  text-align: center;
  cursor: pointer;
  transition: all 0.3s ease;
}
.plan-selection-modal-overlay .plan-selection-modal .plan-content .plans-grid .plan-card:hover {
  border-color: #cbd5e0;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  transform: translateY(-2px);
}
.plan-selection-modal-overlay .plan-selection-modal .plan-content .plans-grid .plan-card.selected {
  border-color: var(--primary-color);
  background: linear-gradient(135deg, rgba(102, 126, 234, 0.05) 0%, rgba(118, 75, 162, 0.05) 100%);
  box-shadow: 0 4px 15px rgba(102, 126, 234, 0.3);
}
.plan-selection-modal-overlay .plan-selection-modal .plan-content .plans-grid .plan-card.blurred {
  opacity: 0.5;
  filter: grayscale(40%);
}
.plan-selection-modal-overlay .plan-selection-modal .plan-content .plans-grid .plan-card.blurred:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  border-color: #cbd5e0;
}
.plan-selection-modal-overlay .plan-selection-modal .plan-content .plans-grid .plan-card.highlighted {
  box-shadow: 0 4px 15px rgba(102, 126, 234, 0.25);
  transform: scale(1.02);
}
.plan-selection-modal-overlay .plan-selection-modal .plan-content .plans-grid .plan-card.highlighted::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(135deg, rgba(102, 126, 234, 0.04) 0%, rgba(118, 75, 162, 0.04) 100%);
  pointer-events: none;
  border-radius: inherit;
  z-index: 0;
}
.plan-selection-modal-overlay .plan-selection-modal .plan-content .plans-grid .plan-card.highlighted:hover {
  transform: scale(1.03);
  box-shadow: 0 6px 20px rgba(102, 126, 234, 0.3);
}
.plan-selection-modal-overlay .plan-selection-modal .plan-content .plans-grid .plan-card .checkmark {
  position: absolute;
  top: 12px;
  right: 12px;
  color: var(--primary-color);
  font-size: 24px;
  z-index: 2;
}
.plan-selection-modal-overlay .plan-selection-modal .plan-content .plans-grid .plan-card .upgrade-badge {
  position: absolute;
  top: -12px;
  right: -12px;
  background: linear-gradient(135deg, var(--primary-color) 0%, #5a4ba0 100%);
  color: white;
  padding: 4px 10px;
  border-radius: 12px;
  font-size: 10px;
  font-weight: 600;
  z-index: 2;
  box-shadow: 0 2px 8px rgba(102, 126, 234, 0.4);
  letter-spacing: 0.3px;
  text-transform: uppercase;
}
.plan-selection-modal-overlay .plan-selection-modal .plan-content .plans-grid .plan-card h4 {
  margin: 0 0 12px;
  font-size: 20px;
  font-weight: 600;
  color: #2d3748;
  position: relative;
  z-index: 1;
}
.plan-selection-modal-overlay .plan-selection-modal .plan-content .plans-grid .plan-card .price {
  margin: 0;
  font-size: 18px;
  font-weight: 700;
  color: var(--primary-color);
  position: relative;
  z-index: 1;
}
.plan-selection-modal-overlay .plan-selection-modal .plan-content .billing-period-section {
  margin-bottom: 24px;
}
.plan-selection-modal-overlay .plan-selection-modal .plan-content .billing-period-section label {
  display: block;
  margin-bottom: 8px;
  font-size: 16px;
  font-weight: 600;
  color: #2d3748;
}
.plan-selection-modal-overlay .plan-selection-modal .plan-content .billing-period-section select {
  width: 100%;
  padding: 12px 16px;
  font-size: 15px;
  border: 2px solid #e2e8f0;
  border-radius: 8px;
  background: white;
  color: #2d3748;
  cursor: pointer;
  transition: border-color 0.3s ease;
}
.plan-selection-modal-overlay .plan-selection-modal .plan-content .billing-period-section select:focus {
  outline: none;
  border-color: var(--primary-color);
}
.plan-selection-modal-overlay .plan-selection-modal .plan-content .billing-period-section select:hover {
  border-color: #cbd5e0;
}
.plan-selection-modal-overlay .plan-selection-modal .plan-content .terms-section {
  margin-bottom: 24px;
}
.plan-selection-modal-overlay .plan-selection-modal .plan-content .terms-section .checkbox-label {
  display: flex;
  align-items: center;
  gap: 10px;
  cursor: pointer;
}
.plan-selection-modal-overlay .plan-selection-modal .plan-content .terms-section .checkbox-label input[type=checkbox] {
  width: 18px;
  height: 18px;
  cursor: pointer;
}
.plan-selection-modal-overlay .plan-selection-modal .plan-content .terms-section .checkbox-label span {
  font-size: 14px;
  color: #4a5568;
}
.plan-selection-modal-overlay .plan-selection-modal .plan-content .terms-section .checkbox-label span .terms-link {
  color: var(--primary-color);
  text-decoration: none;
  font-weight: 600;
}
.plan-selection-modal-overlay .plan-selection-modal .plan-content .terms-section .checkbox-label span .terms-link:hover {
  text-decoration: underline;
}
.plan-selection-modal-overlay .plan-selection-modal .plan-content .payment-status-message {
  margin: 20px 0;
  padding: 16px 20px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  gap: 12px;
  animation: slideDown 0.3s ease-out;
}
@keyframes slideDown {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
.plan-selection-modal-overlay .plan-selection-modal .plan-content .payment-status-message .status-icon {
  flex-shrink: 0;
}
.plan-selection-modal-overlay .plan-selection-modal .plan-content .payment-status-message p {
  margin: 0;
  font-size: 15px;
  font-weight: 600;
  line-height: 1.5;
}
.plan-selection-modal-overlay .plan-selection-modal .plan-content .payment-status-message.success {
  background: linear-gradient(135deg, #d1fae5 0%, #a7f3d0 100%);
  border: 2px solid #6ee7b7;
  color: #065f46;
}
.plan-selection-modal-overlay .plan-selection-modal .plan-content .payment-status-message.success .status-icon {
  color: #059669;
}
.plan-selection-modal-overlay .plan-selection-modal .plan-content .payment-status-message.error {
  background: linear-gradient(135deg, #fee2e2 0%, #fecaca 100%);
  border: 2px solid #fca5a5;
  color: #991b1b;
}
.plan-selection-modal-overlay .plan-selection-modal .plan-content .payment-status-message.error .status-icon {
  color: #dc2626;
}
.plan-selection-modal-overlay .plan-selection-modal .plan-content .payment-status-message.processing {
  background: linear-gradient(135deg, #dbeafe 0%, #bfdbfe 100%);
  border: 2px solid #93c5fd;
  color: #1e40af;
}
.plan-selection-modal-overlay .plan-selection-modal .plan-content .payment-status-message.processing .status-icon {
  color: #3b82f6;
}
.plan-selection-modal-overlay .plan-selection-modal .plan-content .modal-footer {
  text-align: center;
  padding-top: 24px;
  border-top: 1px solid #e2e8f0;
}
.plan-selection-modal-overlay .plan-selection-modal .plan-content .modal-footer .payment-button {
  background: var(--primary-color);
  color: white;
  border: none;
  border-radius: 10px;
  padding: 14px 40px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  width: 100%;
  max-width: 300px;
}
.plan-selection-modal-overlay .plan-selection-modal .plan-content .modal-footer .payment-button:hover:not(:disabled) {
  box-shadow: 0 8px 25px rgba(102, 126, 234, 0.6);
  transform: translateY(-2px);
}
.plan-selection-modal-overlay .plan-selection-modal .plan-content .modal-footer .payment-button:active:not(:disabled) {
  transform: translateY(0);
}
.plan-selection-modal-overlay .plan-selection-modal .plan-content .modal-footer .payment-button:disabled {
  background: #cbd5e0;
  cursor: not-allowed;
  opacity: 0.6;
}
.plan-selection-modal-overlay .plan-selection-modal .plan-content .modal-footer .go-back {
  margin: 16px 0 0;
  font-size: 14px;
  color: #4a5568;
}
.plan-selection-modal-overlay .plan-selection-modal .plan-content .modal-footer .go-back .back-link {
  background: none;
  border: none;
  color: var(--primary-color);
  font-weight: 600;
  cursor: pointer;
  text-decoration: none;
  padding: 0;
  font-size: 14px;
}
.plan-selection-modal-overlay .plan-selection-modal .plan-content .modal-footer .go-back .back-link:hover:not(:disabled) {
  text-decoration: underline;
}
.plan-selection-modal-overlay .plan-selection-modal .plan-content .modal-footer .go-back .back-link:disabled {
  color: #cbd5e0;
  cursor: not-allowed;
}
@media (max-width: 768px) {
  .plan-selection-modal-overlay {
    padding: 16px;
  }
  .plan-selection-modal-overlay .plan-selection-modal .company-info {
    padding: 20px 24px;
  }
  .plan-selection-modal-overlay .plan-selection-modal .company-info h2 {
    font-size: 22px;
  }
  .plan-selection-modal-overlay .plan-selection-modal .company-info .contact-info,
  .plan-selection-modal-overlay .plan-selection-modal .company-info .current-plan {
    font-size: 13px;
  }
  .plan-selection-modal-overlay .plan-selection-modal .plan-content {
    padding: 24px;
  }
  .plan-selection-modal-overlay .plan-selection-modal .plan-content .plans-grid {
    grid-template-columns: 1fr;
    gap: 16px;
  }
  .plan-selection-modal-overlay .plan-selection-modal .plan-content .plans-grid .plan-card.highlighted {
    transform: scale(1.01);
  }
  .plan-selection-modal-overlay .plan-selection-modal .plan-content .plans-grid .plan-card.highlighted:hover {
    transform: scale(1.02);
  }
  .plan-selection-modal-overlay .plan-selection-modal .plan-content .modal-footer .payment-button {
    max-width: 100%;
  }
}
@media (max-width: 480px) {
  .plan-selection-modal-overlay {
    padding: 0;
  }
  .plan-selection-modal-overlay .plan-selection-modal {
    margin: 0;
    border-radius: 0;
    height: 100vh;
    max-height: 100vh;
  }
  .plan-selection-modal-overlay .plan-selection-modal .company-info h2 {
    font-size: 20px;
  }
  .plan-selection-modal-overlay .plan-selection-modal .company-info .contact-info {
    flex-direction: column;
  }
  .plan-selection-modal-overlay .plan-selection-modal .company-info .contact-info span {
    display: block;
    margin: 2px 0;
  }
  .plan-selection-modal-overlay .plan-selection-modal .plan-content .plans-grid .plan-card {
    padding: 20px 16px;
  }
  .plan-selection-modal-overlay .plan-selection-modal .plan-content .plans-grid .plan-card.highlighted {
    transform: scale(1.01);
  }
  .plan-selection-modal-overlay .plan-selection-modal .plan-content .plans-grid .plan-card h4 {
    font-size: 18px;
  }
  .plan-selection-modal-overlay .plan-selection-modal .plan-content .plans-grid .plan-card .price {
    font-size: 16px;
  }
  .plan-selection-modal-overlay .plan-selection-modal .plan-content .plans-grid .plan-card .upgrade-badge {
    top: -10px;
    right: -10px;
    padding: 4px 10px;
    font-size: 9px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/PlanSelectionModal/PlanSelectionModal.scss"],"names":[],"mappings":"AAAA;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,4CAAA;EACA,0BAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;EACA,aAAA;AACF;AACE;EACE,6DAAA;EACA,mBAAA;EACA,0CAAA;EACA,gBAAA;EACA,WAAA;EACA,gBAAA;EACA,gBAAA;EACA,qCAAA;EACA,yBAAA;AACJ;AACI;EACE;IACE,UAAA;IACA,wCAAA;EACN;EACI;IACE,UAAA;IACA,iCAAA;EACN;AACF;AAEI;EACE,kBAAA;EACA,aAAA;EACA,yBAAA;EACA,gCAAA;AAAN;AAEM;EACE,uBAAA;EACA,YAAA;EACA,eAAA;EACA,cAAA;EACA,eAAA;EACA,2BAAA;EACA,UAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAAR;AAEQ;EACE,cAAA;AAAV;AAGQ;EACE,cAAA;EACA,mBAAA;EACA,YAAA;AADV;AAMI;EACE,kBAAA;EACA,kBAAA;EACA,cAAA;EACA,eAAA;AAJN;AAOI;EACE,kBAAA;EACA,kBAAA;EACA,gCAAA;EACA,mBAAA;AALN;AAOM;EACE,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AALR;AAQM;EACE,kBAAA;EACA,eAAA;EACA,cAAA;AANR;AAQQ;EACE,aAAA;AANV;AAUM;EACE,eAAA;EACA,cAAA;AARR;AAUQ;EACE,2BAAA;EACA,gBAAA;AARV;AAaI;EACE,aAAA;AAXN;AAaM;EACE,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AAXR;AAcM;EACE,aAAA;EACA,2DAAA;EACA,SAAA;EACA,mBAAA;AAZR;AAcQ;EACE,kBAAA;EACA,iBAAA;EACA,yBAAA;EACA,mBAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,yBAAA;AAZV;AAcU;EACE,qBAAA;EACA,yCAAA;EACA,2BAAA;AAZZ;AAeU;EACE,kCAAA;EACA,gGAAA;EACA,+CAAA;AAbZ;AAgBU;EACE,YAAA;EACA,sBAAA;AAdZ;AAgBY;EACE,2BAAA;EACA,yCAAA;EACA,qBAAA;AAdd;AAkBS;EACP,gDAAA;EACA,sBAAA;AAhBF;AAkBE;EACE,WAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,gGAAA;EACA,oBAAA;EACA,sBAAA;EACA,UAAA;AAhBJ;AAmBE;EACE,sBAAA;EACA,+CAAA;AAjBJ;AAqBU;EACE,kBAAA;EACA,SAAA;EACA,WAAA;EACA,2BAAA;EACA,eAAA;EACA,UAAA;AAnBZ;AAsBU;EACE,kBAAA;EACA,UAAA;EACA,YAAA;EACA,0EAAA;EACA,YAAA;EACA,iBAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,UAAA;EACA,8CAAA;EACA,qBAAA;EACA,yBAAA;AApBZ;AAuBU;EACE,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,UAAA;AArBZ;AAwBU;EACE,SAAA;EACA,eAAA;EACA,gBAAA;EACA,2BAAA;EACA,kBAAA;EACA,UAAA;AAtBZ;AA2BM;EACE,mBAAA;AAzBR;AA2BQ;EACE,cAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AAzBV;AA4BQ;EACE,WAAA;EACA,kBAAA;EACA,eAAA;EACA,yBAAA;EACA,kBAAA;EACA,iBAAA;EACA,cAAA;EACA,eAAA;EACA,kCAAA;AA1BV;AA4BU;EACE,aAAA;EACA,kCAAA;AA1BZ;AA6BU;EACE,qBAAA;AA3BZ;AAgCM;EACE,mBAAA;AA9BR;AAgCQ;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,eAAA;AA9BV;AAgCU;EACE,WAAA;EACA,YAAA;EACA,eAAA;AA9BZ;AAiCU;EACE,eAAA;EACA,cAAA;AA/BZ;AAiCY;EACE,2BAAA;EACA,qBAAA;EACA,gBAAA;AA/Bd;AAiCc;EACE,0BAAA;AA/BhB;AAsCM;EACE,cAAA;EACA,kBAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,SAAA;EACA,kCAAA;AApCR;AAsCQ;EACE;IACE,UAAA;IACA,4BAAA;EApCV;EAsCQ;IACE,UAAA;IACA,wBAAA;EApCV;AACF;AAuCQ;EACE,cAAA;AArCV;AAwCQ;EACE,SAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;AAtCV;AAyCQ;EACE,6DAAA;EACA,yBAAA;EACA,cAAA;AAvCV;AAyCU;EACE,cAAA;AAvCZ;AA2CQ;EACE,6DAAA;EACA,yBAAA;EACA,cAAA;AAzCV;AA2CU;EACE,cAAA;AAzCZ;AA6CQ;EACE,6DAAA;EACA,yBAAA;EACA,cAAA;AA3CV;AA6CU;EACE,cAAA;AA3CZ;AAgDM;EACE,kBAAA;EACA,iBAAA;EACA,6BAAA;AA9CR;AAgDQ;EACE,gCAAA;EACA,YAAA;EACA,YAAA;EACA,mBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,yBAAA;EACA,WAAA;EACA,gBAAA;AA9CV;AAgDU;EACE,+CAAA;EACA,2BAAA;AA9CZ;AAiDU;EACE,wBAAA;AA/CZ;AAkDU;EACE,mBAAA;EACA,mBAAA;EACA,YAAA;AAhDZ;AAoDQ;EACE,gBAAA;EACA,eAAA;EACA,cAAA;AAlDV;AAoDU;EACE,gBAAA;EACA,YAAA;EACA,2BAAA;EACA,gBAAA;EACA,eAAA;EACA,qBAAA;EACA,UAAA;EACA,eAAA;AAlDZ;AAoDY;EACE,0BAAA;AAlDd;AAqDY;EACE,cAAA;EACA,mBAAA;AAnDd;AA4DE;EA/ZF;IAgaI,aAAA;EAzDF;EA4DI;IACE,kBAAA;EA1DN;EA4DM;IACE,eAAA;EA1DR;EA6DM;;IAEE,eAAA;EA3DR;EA+DI;IACE,aAAA;EA7DN;EA+DM;IACE,0BAAA;IACA,SAAA;EA7DR;EAgEU;IACE,sBAAA;EA9DZ;EAgEY;IACE,sBAAA;EA9Dd;EAqEQ;IACE,eAAA;EAnEV;AACF;AAyEE;EA3cF;IA4cI,UAAA;EAtEF;EAwEE;IACE,SAAA;IACA,gBAAA;IACA,aAAA;IACA,iBAAA;EAtEJ;EAyEM;IACE,eAAA;EAvER;EA0EM;IACE,sBAAA;EAxER;EA0EQ;IACE,cAAA;IACA,aAAA;EAxEV;EA+EQ;IACE,kBAAA;EA7EV;EA+EU;IACE,sBAAA;EA7EZ;EAgFU;IACE,eAAA;EA9EZ;EAiFU;IACE,eAAA;EA/EZ;EAkFU;IACE,UAAA;IACA,YAAA;IACA,iBAAA;IACA,cAAA;EAhFZ;AACF","sourcesContent":[".plan-selection-modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgba(195, 191, 191, 0.721);\n  backdrop-filter: blur(4px);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 10000;\n  padding: 20px;\n\n  .plan-selection-modal {\n    background: linear-gradient(135deg, #ffffff 0%, #f8fafc 100%);\n    border-radius: 16px;\n    box-shadow: 0 25px 50px rgba(0, 0, 0, 0.3);\n    max-width: 900px;\n    width: 100%;\n    max-height: 90vh;\n    overflow-y: auto;\n    animation: modalSlideIn 0.3s ease-out;\n    border: 1px solid #e2e8f0;\n\n    @keyframes modalSlideIn {\n      from {\n        opacity: 0;\n        transform: translateY(-20px) scale(0.95);\n      }\n      to {\n        opacity: 1;\n        transform: translateY(0) scale(1);\n      }\n    }\n\n    .modal-header {\n      padding: 16px 24px;\n      display: flex;\n      justify-content: flex-end;\n      border-bottom: 1px solid #e2e8f0;\n\n      .close-button {\n        background: transparent;\n        border: none;\n        font-size: 24px;\n        color: #4a5568;\n        cursor: pointer;\n        transition: color 0.3s ease;\n        padding: 0;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n\n        &:hover:not(:disabled) {\n          color: #2d3748;\n        }\n\n        &:disabled {\n          color: #cbd5e0;\n          cursor: not-allowed;\n          opacity: 0.5;\n        }\n      }\n    }\n\n    .loading-container {\n      padding: 60px 32px;\n      text-align: center;\n      color: #4a5568;\n      font-size: 16px;\n    }\n\n    .company-info {\n      padding: 24px 32px;\n      text-align: center;\n      border-bottom: 1px solid #e2e8f0;\n      background: #f8fafc;\n\n      h2 {\n        margin: 0 0 12px;\n        font-size: 26px;\n        font-weight: 700;\n        color: #1a202c;\n      }\n\n      .contact-info {\n        margin-bottom: 8px;\n        font-size: 14px;\n        color: #4a5568;\n\n        span {\n          margin: 0 4px;\n        }\n      }\n\n      .current-plan {\n        font-size: 14px;\n        color: #4a5568;\n\n        strong {\n          color: var(--primary-color);\n          font-weight: 600;\n        }\n      }\n    }\n\n    .plan-content {\n      padding: 32px;\n\n      .section-title {\n        margin: 0 0 20px;\n        font-size: 18px;\n        font-weight: 600;\n        color: #2d3748;\n      }\n\n      .plans-grid {\n        display: grid;\n        grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));\n        gap: 20px;\n        margin-bottom: 32px;\n\n        .plan-card {\n          position: relative;\n          background: white;\n          border: 2px solid #e2e8f0;\n          border-radius: 12px;\n          padding: 24px 20px;\n          text-align: center;\n          cursor: pointer;\n          transition: all 0.3s ease;\n\n          &:hover {\n            border-color: #cbd5e0;\n            box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);\n            transform: translateY(-2px);\n          }\n\n          &.selected {\n            border-color: var(--primary-color);\n            background: linear-gradient(135deg, rgba(102, 126, 234, 0.05) 0%, rgba(118, 75, 162, 0.05) 100%);\n            box-shadow: 0 4px 15px rgba(102, 126, 234, 0.3);\n          }\n\n          &.blurred {\n            opacity: 0.5;\n            filter: grayscale(40%);\n            \n            &:hover {\n              transform: translateY(-2px);\n              box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);\n              border-color: #cbd5e0;\n            }\n          }\n\n         &.highlighted {\n  box-shadow: 0 4px 15px rgba(102, 126, 234, 0.25);\n  transform: scale(1.02);\n  \n  &::before {\n    content: '';\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background: linear-gradient(135deg, rgba(102, 126, 234, 0.04) 0%, rgba(118, 75, 162, 0.04) 100%);\n    pointer-events: none;\n    border-radius: inherit;\n    z-index: 0;\n  }\n  \n  &:hover {\n    transform: scale(1.03);\n    box-shadow: 0 6px 20px rgba(102, 126, 234, 0.3);\n  }\n}\n\n          .checkmark {\n            position: absolute;\n            top: 12px;\n            right: 12px;\n            color: var(--primary-color);\n            font-size: 24px;\n            z-index: 2;\n          }\n\n          .upgrade-badge {\n            position: absolute;\n            top: -12px;\n            right: -12px;\n            background: linear-gradient(135deg, var(--primary-color) 0%, #5a4ba0 100%);\n            color: white;\n            padding: 4px 10px;\n            border-radius: 12px;\n            font-size: 10px;\n            font-weight: 600;\n            z-index: 2;\n            box-shadow: 0 2px 8px rgba(102, 126, 234, 0.4);\n            letter-spacing: 0.3px;\n            text-transform: uppercase;\n          }\n\n          h4 {\n            margin: 0 0 12px;\n            font-size: 20px;\n            font-weight: 600;\n            color: #2d3748;\n            position: relative;\n            z-index: 1;\n          }\n\n          .price {\n            margin: 0;\n            font-size: 18px;\n            font-weight: 700;\n            color: var(--primary-color);\n            position: relative;\n            z-index: 1;\n          }\n        }\n      }\n\n      .billing-period-section {\n        margin-bottom: 24px;\n\n        label {\n          display: block;\n          margin-bottom: 8px;\n          font-size: 16px;\n          font-weight: 600;\n          color: #2d3748;\n        }\n\n        select {\n          width: 100%;\n          padding: 12px 16px;\n          font-size: 15px;\n          border: 2px solid #e2e8f0;\n          border-radius: 8px;\n          background: white;\n          color: #2d3748;\n          cursor: pointer;\n          transition: border-color 0.3s ease;\n\n          &:focus {\n            outline: none;\n            border-color: var(--primary-color);\n          }\n\n          &:hover {\n            border-color: #cbd5e0;\n          }\n        }\n      }\n\n      .terms-section {\n        margin-bottom: 24px;\n\n        .checkbox-label {\n          display: flex;\n          align-items: center;\n          gap: 10px;\n          cursor: pointer;\n\n          input[type=\"checkbox\"] {\n            width: 18px;\n            height: 18px;\n            cursor: pointer;\n          }\n\n          span {\n            font-size: 14px;\n            color: #4a5568;\n\n            .terms-link {\n              color: var(--primary-color);\n              text-decoration: none;\n              font-weight: 600;\n\n              &:hover {\n                text-decoration: underline;\n              }\n            }\n          }\n        }\n      }\n\n      .payment-status-message {\n        margin: 20px 0;\n        padding: 16px 20px;\n        border-radius: 10px;\n        display: flex;\n        align-items: center;\n        gap: 12px;\n        animation: slideDown 0.3s ease-out;\n\n        @keyframes slideDown {\n          from {\n            opacity: 0;\n            transform: translateY(-10px);\n          }\n          to {\n            opacity: 1;\n            transform: translateY(0);\n          }\n        }\n\n        .status-icon {\n          flex-shrink: 0;\n        }\n\n        p {\n          margin: 0;\n          font-size: 15px;\n          font-weight: 600;\n          line-height: 1.5;\n        }\n\n        &.success {\n          background: linear-gradient(135deg, #d1fae5 0%, #a7f3d0 100%);\n          border: 2px solid #6ee7b7;\n          color: #065f46;\n\n          .status-icon {\n            color: #059669;\n          }\n        }\n\n        &.error {\n          background: linear-gradient(135deg, #fee2e2 0%, #fecaca 100%);\n          border: 2px solid #fca5a5;\n          color: #991b1b;\n\n          .status-icon {\n            color: #dc2626;\n          }\n        }\n\n        &.processing {\n          background: linear-gradient(135deg, #dbeafe 0%, #bfdbfe 100%);\n          border: 2px solid #93c5fd;\n          color: #1e40af;\n\n          .status-icon {\n            color: #3b82f6;\n          }\n        }\n      }\n\n      .modal-footer {\n        text-align: center;\n        padding-top: 24px;\n        border-top: 1px solid #e2e8f0;\n\n        .payment-button {\n          background: var(--primary-color);\n          color: white;\n          border: none;\n          border-radius: 10px;\n          padding: 14px 40px;\n          font-size: 16px;\n          font-weight: 600;\n          cursor: pointer;\n          transition: all 0.3s ease;\n          width: 100%;\n          max-width: 300px;\n\n          &:hover:not(:disabled) {\n            box-shadow: 0 8px 25px rgba(102, 126, 234, 0.6);\n            transform: translateY(-2px);\n          }\n\n          &:active:not(:disabled) {\n            transform: translateY(0);\n          }\n\n          &:disabled {\n            background: #cbd5e0;\n            cursor: not-allowed;\n            opacity: 0.6;\n          }\n        }\n\n        .go-back {\n          margin: 16px 0 0;\n          font-size: 14px;\n          color: #4a5568;\n\n          .back-link {\n            background: none;\n            border: none;\n            color: var(--primary-color);\n            font-weight: 600;\n            cursor: pointer;\n            text-decoration: none;\n            padding: 0;\n            font-size: 14px;\n\n            &:hover:not(:disabled) {\n              text-decoration: underline;\n            }\n\n            &:disabled {\n              color: #cbd5e0;\n              cursor: not-allowed;\n            }\n          }\n        }\n      }\n    }\n  }\n\n  // Mobile responsiveness\n  @media (max-width: 768px) {\n    padding: 16px;\n\n    .plan-selection-modal {\n      .company-info {\n        padding: 20px 24px;\n\n        h2 {\n          font-size: 22px;\n        }\n\n        .contact-info,\n        .current-plan {\n          font-size: 13px;\n        }\n      }\n\n      .plan-content {\n        padding: 24px;\n\n        .plans-grid {\n          grid-template-columns: 1fr;\n          gap: 16px;\n\n          .plan-card {\n            &.highlighted {\n              transform: scale(1.01);\n              \n              &:hover {\n                transform: scale(1.02);\n              }\n            }\n          }\n        }\n\n        .modal-footer {\n          .payment-button {\n            max-width: 100%;\n          }\n        }\n      }\n    }\n  }\n\n  @media (max-width: 480px) {\n    padding: 0;\n\n    .plan-selection-modal {\n      margin: 0;\n      border-radius: 0;\n      height: 100vh;\n      max-height: 100vh;\n\n      .company-info {\n        h2 {\n          font-size: 20px;\n        }\n\n        .contact-info {\n          flex-direction: column;\n          \n          span {\n            display: block;\n            margin: 2px 0;\n          }\n        }\n      }\n\n      .plan-content {\n        .plans-grid {\n          .plan-card {\n            padding: 20px 16px;\n\n            &.highlighted {\n              transform: scale(1.01);\n            }\n\n            h4 {\n              font-size: 18px;\n            }\n\n            .price {\n              font-size: 16px;\n            }\n\n            .upgrade-badge {\n              top: -10px;\n              right: -10px;\n              padding: 4px 10px;\n              font-size: 9px;\n            }\n          }\n        }\n      }\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
